import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { DeviceDetectorService } from 'ngx-device-detector';
import { BreakpointService } from 'src/app/core/services/breakpoint.service';

import Radar from 'radar-sdk-js';
import RadarMap from 'radar-sdk-js/dist/ui/RadarMap';

@Component({
  standalone: true,
  selector: 'app-simple-map',
  templateUrl: './simple-map.component.html',
  styleUrls: ['../maps.style.scss'],
})
export class SimpleMapComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() coordinates: any;

  private map: RadarMap;

  @ViewChild('map') private mapElement: ElementRef<HTMLElement>;

  readonly #ngZone: NgZone = inject(NgZone);
  readonly #deviceDetectorService: DeviceDetectorService = inject(
    DeviceDetectorService,
  );

  constructor(private readonly breakpointService: BreakpointService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.coordinates && changes.coordinates.currentValue) {
      if (this.map) {
        this.map.setCenter(changes.coordinates.currentValue);
      }
    }
  }

  ngAfterViewInit(): void {
    this.initSimpleMap(this.coordinates);
  }

  ngOnDestroy(): void {
    const userAgent: string = this.#deviceDetectorService.userAgent;
    if (userAgent && this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  initSimpleMap(coordinates: any): void {
    const userAgent: string = this.#deviceDetectorService.userAgent;

    if (userAgent) {
      this.#ngZone.runOutsideAngular(() => {
        this.map = Radar.ui.map({
          container: this.mapElement.nativeElement,
          style: 'radar-default-v1',
          showZoomControls: false,
          center: coordinates,
          scrollZoom: false,
          zoom: this.breakpointService.isDesktop() ? 5 : 4.15,
        });
      });
    }
  }
}
